import $ from 'jquery';
import CancelPolicyBalloonClass from '../hotel/CancelPolicyBalloonClass';
import GlobalHeaderClass from './GlobalHeaderClass';
import HotelDetailModalClass from '../hotel/HotelDetailModalClass';
import HotelPlanModalClass from '../hotel/HotelPlanModalClass';
import ImageGalleryClass from '../hotel/ImageGalleryClass';
import ImageSlideClass from '../../libs/ui/ImageSlideClass';
import InputSupportKanaToHebonClass from './InputSupportKanaToHebonClass';
import MapEmbedClass from './MapEmbedClass';
import MapModalClass from '../hotel/MapModalClass';
import MultiCheckBaseClass from './MultiCheckBaseClass';
import RadioUncheckClass from './RadioUncheckClass';
import ReceiptModalClass from '../mypage/ReceiptModalClass';
import ReciptSelectModalClass from '../mypage/ReciptSelectModalClass';
import TabBaseClass from './TabBaseClass';
import ThingsManagerClass from '../../libs/base/ThingsManagerClass';
import ToggleBaseClass from './ToggleBaseClass';
import TripadvisorBalloonClass from '../hotel/TripadvisorBalloonClass';
import Util from '../../libs/util/Util';

/**
 * 汎用品を適用・管理
 */
export default class PartsManagerClass extends ThingsManagerClass {
  constructor() {
    super();
    this.name = 'PartsManagerClass';
  }

  onCreate() {

    const self = this;
    this.things = {};

    this.things.gHeader = new GlobalHeaderClass();

    this.things.receiptModal = new ReceiptModalClass();
    this.things.receiptSelectModal = new ReciptSelectModalClass();

    this.things.tripadvisorBalloon = new TripadvisorBalloonClass();
    this.things.cancelpolicyBalloon = new CancelPolicyBalloonClass();

    this.things.mapModal = new MapModalClass();
    this.things.hotelPlanModal = new HotelPlanModalClass();
    this.things.hotelDetailModal = new HotelDetailModalClass();

    $('[data-toggle_target]').each((index, element) => {
      const id = $(element).attr('data-toggle_target');
      if (!self.things['toggle_' + id]) {
        self.things['toggle_' + id] = new ToggleBaseClass(id);
      }
    });

    $('[data-tab_target]').each((index, element) => {
      const id = $(element).attr('data-tab_target');
      if (!self.things['tab_' + id]) {
        self.things['tab_' + id] = new TabBaseClass(id);
      }
    });

    $('[data-multicheck]').each((index, element) => {
      const id = $(element).attr('data-multicheck');
      if (!self.things['multicheck_' + id]) {
        self.things['multicheck_' + id] = new MultiCheckBaseClass(id);
      }
    });

    $('[data-kanatohebon]').each((index, element) => {
      const id = $(element).attr('data-kanatohebon');
      if (!self.things['kanatohebon_' + id]) {
        self.things['kanatohebon_' + id] = new InputSupportKanaToHebonClass(id);
      }
    });

    $('[data-radio_uncheck]').each((index, element) => {
      if (!self.things['radio_uncheck_' + index]) {
        self.things['radio_uncheck_' + index] = new RadioUncheckClass($(element));
      }
    });

    $('.wrap_image_slide_gallery').each((index, element) => {
      if (!self.things['image_gallery_' + index]) {
        self.things['image_gallery_' + index] = new ImageGalleryClass($(element));
      }
    });

    $('.wrap_map_embed').each((index, element) => {
      if (!self.things['map_embed_' + index]) {
        self.things['map_embed_' + index] = new MapEmbedClass($(element));
      }
    });

    $('.wrap_slide_gallery_free_frame').each((index, element) => {
      if (!self.things['wrap_slide_gallery_free_frame_' + index]) {
        const _this = $(element);
        const slide = new ImageSlideClass(_this);
        const cl = _this.attr('class');
        if (cl.indexOf('type1') === -1) {
          slide.isBlockLoop = false;
          slide.isAutoStart = false;
        }
        if (cl.indexOf('type2') !== -1) {
          slide.slideItemNum = (Util.isBreakpoint) ? 1 : 4;
        } else {
          slide.slideItemNum = (Util.isBreakpoint) ? 1 : 3;
        }
        self.things['wrap_slide_gallery_free_frame_' + index] = slide;
      }
    });

    super.onCreate();
  }
}
